import React from 'react';
import BotonImagen from '../UI/botones/BotonImagen';
import BotonUpDown from '../UI/botones/BotonUpDown';
import * as Iconos from '../UI/Iconos.js';
import * as Titularidad from '../constantes/Titularidad.js';
import * as Funciones from '../funciones/FuncionesPartidos.js';
import { Boton } from '../funciones/FuncionesFormacion';
import styles from './BotoneraJugador.module.css';

const BotoneraJugador = (props) => {
  const participante = props.participante;
  const editar = props.editar;
  const cantSuplentes = props.cantSuplentes;

  const onClickBoton = (boton) => {
    props.onClickBoton(boton);
  };

  const deshabilitarBotonera = participante.idPartidoFormacion === 0;
  const jugadorCargado =
    (participante.persona && participante.persona.id) ||
    (participante.personaSinId && participante.personaSinId.apellido);

  return (
    <React.Fragment>
      {editar && (
        <React.Fragment>
          <BotonImagen
            name={Boton.CANCELAR}
            id={participante.orden}
            imagen={Iconos.cancelar}
            estiloImagen={styles.botonEdicion}
            alt="Editar"
            onClick={onClickBoton}
          />
          <BotonImagen
            name={Boton.BORRAR}
            id={participante.orden}
            imagen={Iconos.borrar}
            estiloImagen={styles.botonEdicion}
            alt="Borrar"
            onClick={onClickBoton}
          />
        </React.Fragment>
      )}
      {jugadorCargado && !editar && (
        <React.Fragment>
          <BotonImagen
            name={Boton.EDITAR}
            id={participante.orden}
            imagen={Iconos.editar}
            estiloImagen={styles.botonEdicion}
            alt="Editar"
            onClick={onClickBoton}
          />
          {(participante.titularidad === Titularidad.TITULAR ||
            (participante.titularidad === Titularidad.SUPLENTE &&
              participante.idSustitucionEntra)) && (
            <BotonImagen
              name={Boton.GOL}
              id={participante.orden}
              imagen={deshabilitarBotonera ? Iconos.golDisabled : Iconos.gol}
              disabled={deshabilitarBotonera}
              estiloImagen={styles.botonEdicion}
              alt="Agregar gol"
              onClick={onClickBoton}
            />
          )}
          {cantSuplentes > 0 && (
            <React.Fragment>
              {participante.titularidad === Titularidad.SUPLENTE && (
                <BotonUpDown
                  boton={Boton.ENTRA}
                  id={participante.orden}
                  presionado={participante.idSustitucionEntra}
                  disabled={deshabilitarBotonera}
                  tooltip={
                    participante.idSustitucionEntra
                      ? Funciones.TooltipTiempos(
                          participante.tiempoEntra,
                          participante.minutosEntra
                        )
                      : ''
                  }
                  estiloImagen={styles.botonCambio}
                  onClick={onClickBoton}
                />
              )}
              {(participante.titularidad === Titularidad.TITULAR ||
                (participante.titularidad === Titularidad.SUPLENTE &&
                  participante.idSustitucionEntra)) && (
                <BotonUpDown
                  boton={Boton.SALE}
                  id={participante.orden}
                  presionado={participante.idSustitucionSale}
                  disabled={deshabilitarBotonera}
                  tooltip={
                    participante.idSustitucionSale
                      ? Funciones.TooltipTiempos(participante.tiempoSale, participante.minutosSale)
                      : ''
                  }
                  estiloImagen={styles.botonCambio}
                  onClick={onClickBoton}
                />
              )}
            </React.Fragment>
          )}
          <BotonUpDown
            boton={Boton.AMARILLA}
            id={participante.orden}
            presionado={participante.amonestado}
            disabled={deshabilitarBotonera}
            tooltip=""
            estiloImagen={styles.botonTarjeta}
            onClick={onClickBoton}
          />
          <BotonUpDown
            boton={Boton.ROJA}
            id={participante.orden}
            presionado={participante.expulsado}
            disabled={deshabilitarBotonera}
            tooltip={
              participante.expulsado
                ? Funciones.TooltipTiempos(
                    participante.tiempoExpulsado,
                    participante.minutosExpulsado
                  )
                : ''
            }
            estiloImagen={styles.botonTarjeta}
            onClick={onClickBoton}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default BotoneraJugador;
